<template>
  <div>
    <template v-for="(item, index) in items" >
      <component :is="item.items?'div':'a'"  :class="itemClass" @click="$emit('click-item',item);stopPropagation?$event.stopPropagation():null;item.items?handleClickItem(item):item.action?item.action(item,index):menuAction?menuAction(item,index):null"
                 style="display: block"
                 :style="[itemStyle,mouseHover==item?itemStyleMouseOver:{},itemStyleActiveTrigger&&itemStyleActiveTrigger(item,index)?itemStyleActive:{}]"
                 @mouseover="mouseHover=item" @mouseleave="mouseHover=null">

        <div :style="itemTitleStyle">
          <i v-if="item.icon" :class="item.icon"></i>
          <span>{{item.title}}</span>
          <!--<template v-if="item.items">-->
          <i v-if="item.items" class="dropdown icon" style="margin-left:auto;"></i>
        </div>

        <menu-item v-if="item.items" :style="[subMenuStyle,(clickTriggerForOpenSubMenu?isOpenItem(item):mouseHover==item)?openSubMenuStyle:hideSubMenuStyle]" :items="item.items" :class="subMenuClass"
                   :menuAction="menuAction" :isCollapsed="isCollapsed" :subMenuClass="subMenuClass" :subMenuStyle="subMenuStyle" :hideSubMenuStyle="hideSubMenuStyle" :openSubMenuStyle="openSubMenuStyle"
                   :stopPropagation="stopPropagation" :itemStyleActive="itemStyleActive" :itemStyleActiveTrigger="itemStyleActiveTrigger" :itemClass="itemClass" :itemStyle="itemStyle" :clickTriggerForOpenSubMenu="clickTriggerForOpenSubMenu"
                   @click-item="$emit('click-item',$event)"
        ></menu-item>
        <!--</template>-->
      </component>

    </template>
  </div>
</template>

<script>
  export default {
    name: "menu-item",
    props:{
      menuAction:{
        type:Function
      },
      stopPropagation:{
        type:Boolean,
        default:true
      },
      isCollapsed:{
        type:Boolean,
        default:true
      },
      subMenuClass:{
        type:String,
        default:"menu"
      },
      subMenuStyle:{
        type:Object,
        default:()=>{return {}}
      },
      clickTriggerForOpenSubMenu:{
        type:Boolean,
        default:true
      },
      hideSubMenuStyle:{
        type:Object,
        default:()=>{return {}}
      },
      openSubMenuStyle:{
        type:Object,
        default:()=>{return {
          "display":'block !important'
        }}
      },
      itemClass:{
        type:String,
        default:"item"
      },
      itemStyle:{
        type:Object,
        default:()=>{return {}}
      },
      itemStyleActive:{
        type:Object,
        default:()=>{return {}}
      },
      itemStyleMouseOver:{
        type:Object,
        default:()=>{return {}}
      },
      itemStyleActiveTrigger:{
        type:Function
      },
      itemTitleStyle:{
        type:[Object,String],
        default:"display: flex"
      },
      items:{
        type:Array,
        default:()=>[]
      },
      storePath:{
        type:String,
      }

    },
    data(){
      return {
        openedItems:this.getInitOpenedItems(),
        mouseHover:null,//компонент над, которым находится мышка
      }
    },
    methods:{
      getInitOpenedItems(){
        return  this.isCollapsed?this.items.filter(i=>i.items):[];
      },
      handleClickItem(item){
        if (item.items){
          if (this.storePath&&item.id){
            const storePath = this.storePath+"."+item.id;
            const currentValue = !!this.$store.getters.getUserValueByPath(storePath);
            this.$store.commit('setUserValue',{path:storePath,value:!currentValue})
          }

          const itemIndex = this.openedItems.indexOf(item);
          itemIndex==-1?this.openedItems.push(item):this.openedItems.splice(itemIndex, 1)
        }
      },
      isOpenItem(item){
        if (this.storePath&&item.id){
          if (this.$store.getters.getUserValueByPath(this.storePath+"."+item.id)) return true;
          return false;
        }
        return this.openedItems.indexOf(item)!=-1;
      }
    }

  }
</script>

<style scoped>

</style>
